import { render, staticRenderFns } from "./DeleteMyAccount.vue?vue&type=template&id=a6b60eec&"
import script from "./DeleteMyAccount.vue?vue&type=script&lang=js&"
export * from "./DeleteMyAccount.vue?vue&type=script&lang=js&"
import style0 from "./DeleteMyAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports